import React, { useEffect, useState } from 'react'
import { NavLink, Outlet } from 'react-router-dom';

const NavBar = () => {
  const [onscroll, setOnscroll] = useState(0)

  useEffect(() => {
    const scrollEvent = () => {
      setOnscroll(oldValue => {
        return oldValue = window.scrollY
      })
    }
    window.addEventListener("scroll", scrollEvent)

    return () => window.removeEventListener("scroll", scrollEvent)
  }, [])

  return (
    <div>
      <header className={`header-container ${onscroll >= 10 ? "onscroll" : ""}`} >
        <div className="brand-container">
          <h1 className="brand-name">Ad</h1>
          <small>aremudami_luxury</small>
        </div>

        <nav className="nav-container"  aria-label="primary navigation" > 
          <ul className="list-items">
            <li className="list-child"> 
              <NavLink to={"/"}>Home</NavLink>
            </li>
            <li className="list-child">
              <NavLink to={"listing"}>Property Listing</NavLink>
            </li>
            <li className="list-child"> 
              <NavLink to={"about"}>About</NavLink>
            </li>
            <li className="list-child">
              <NavLink to={"contact"}>Contact</NavLink>
            </li>
          </ul>
        </nav>
      </header>
      
      <Outlet />
    </div>
  )
}

export default NavBar
